import { render, staticRenderFns } from "./Exclusivelodgings.vue?vue&type=template&id=1a27d9bb&scoped=true&"
import script from "./Exclusivelodgings.vue?vue&type=script&lang=js&"
export * from "./Exclusivelodgings.vue?vue&type=script&lang=js&"
import style0 from "./Exclusivelodgings.vue?vue&type=style&index=0&id=1a27d9bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a27d9bb",
  null
  
)

export default component.exports